import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SupplierStateModel } from '../models/supplier-state.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class SupplierStateService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);

  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.supplierApiUrl}api/`
  }
  
  getSupplierStates(): Observable<Array<SupplierStateModel>> {
    return this.http.get<Array<SupplierStateModel>>(this.backUrl + 'ProviderState');
  }
}
